/**
 * Works Archive スクロールアニメーション
 * 
 * @package LIVMO
 * @version 1.0.0
 */

(function() {
    'use strict';

    // Works Archive アニメーション初期化
    function initWorksArchive() {
        // GSAPプラグイン登録（関数内で実行して安全性を確保）
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
            gsap.registerPlugin(ScrollTrigger);
        } else {
            return;
        }
        const waContent = document.querySelector('.wa__content');
        const waItems = document.querySelectorAll('.wa__item');
        // 各項目のページャーを個別に取得
        const waPagers = document.querySelectorAll('.wa__pager');
        const pagerCurrents = document.querySelectorAll('.wa__pager-current');
        
        if (!waContent || !waItems.length) {
            // 要素が見つからない場合は静かに終了
            return;
        }
        
        // 各アイテムの詳細情報を確認
        waItems.forEach((item, index) => {
            const bgFrames = item.querySelectorAll('.wa__backgrounds .wa__background, .wa__background');
            const imgFrames = item.querySelectorAll('.wa__images .wa__image, .wa__image');
            const title = item.querySelector('.wa__title');
            const descriptions = item.querySelectorAll('.wa__description');
            
        });

        // 高さ設定は削除（CSSで制御）

        // テキスト分割用の関数（span > b 構造で生成）
        function splitText(element) {
            if (!element) return null;
            
            // .wa__title の場合、子要素（.wa__title-bold, .wa__title-normal）があるかチェック
            const childSpans = element.querySelectorAll('.wa__title-bold, .wa__title-normal');
            if (childSpans.length > 0) {
                // 子要素がある場合、それぞれを処理
                const allChars = [];
                element.innerHTML = ''; // 一旦クリア
                
                childSpans.forEach((childSpan, index) => {
                    // 子要素のHTMLを取得（<br sp-only />を保持するため）
                    const originalHTML = childSpan.innerHTML;
                    
                    // <br sp-only />タグを検出
                    const brSpOnlyRegex = /<br\s+sp-only\s*\/?>/gi;
                    const hasBrSpOnly = brSpOnlyRegex.test(originalHTML);
                    
                    // テキストを取得（<br sp-only />を一時的にマーカーに置換）
                    const textWithMarker = originalHTML.replace(brSpOnlyRegex, '|||BR_SP_ONLY|||');
                    const normalized = textWithMarker
                        .replace(/<[^>]*>/g, '') // HTMLタグを除去
                        .replace(/[\u00A0\u3000]/g, ' ')
                        .replace(/[\s\t\r\n]+/g, ' ')
                        .trim();
                    
                    // スマホの時だけ、wa__title-normalとwa__title-boldの部分で改行位置を制御
                    const isMobile = window.innerWidth <= 767;
                    const isTitleNormal = childSpan.classList.contains('wa__title-normal');
                    const isTitleBold = childSpan.classList.contains('wa__title-bold');
                    const needsInlineDisplay = isMobile && (isTitleNormal || isTitleBold);
                    
                    // 各文字を span > b 構造に変換
                    let brPositions = [];
                    if (hasBrSpOnly) {
                        // マーカーの位置を記録
                        const markerIndex = textWithMarker.indexOf('|||BR_SP_ONLY|||');
                        if (markerIndex !== -1) {
                            // マーカーより前の文字数をカウント
                            const beforeMarker = textWithMarker.substring(0, markerIndex).replace(/<[^>]*>/g, '').trim();
                            brPositions.push(beforeMarker.length);
                        }
                    }
                    
                    const movers = normalized.split('').map((char, charIndex) => {
                        const span = document.createElement('span');
                        // スマホの時だけ、wa__title-normalとwa__title-boldの部分はinlineにする
                        span.style.display = needsInlineDisplay ? 'inline' : 'inline-block';
                        span.className = childSpan.className; // 元のクラスを継承

                        const bold = document.createElement('b');
                        bold.textContent = char === ' ' ? '\u00A0' : char;
                        bold.style.display = 'inline-block';
                        bold.style.transform = 'translateY(120%)';
                        bold.style.opacity = '0';

                        span.appendChild(bold);
                        allChars.push(bold);
                        return span;
                    });
                    
                    // 子要素を追加（<br sp-only />の位置で改行を挿入）
                    movers.forEach((span, charIndex) => {
                        element.appendChild(span);
                        
                        // <br sp-only />の位置で改行を挿入
                        if (brPositions.includes(charIndex + 1)) {
                            const br = document.createElement('br');
                            br.setAttribute('sp-only', '');
                            element.appendChild(br);
                        }
                    });
                    
                    // 最後の要素でない場合、スペースを追加
                    if (index < childSpans.length - 1) {
                        const spaceSpan = document.createElement('span');
                        spaceSpan.style.display = 'inline-block';
                        spaceSpan.className = 'wa__title-space';
                        const spaceBold = document.createElement('b');
                        spaceBold.textContent = '\u00A0';
                        spaceBold.style.display = 'inline-block';
                        spaceBold.style.transform = 'translateY(120%)';
                        spaceBold.style.opacity = '0';
                        spaceSpan.appendChild(spaceBold);
                        element.appendChild(spaceSpan);
                        allChars.push(spaceBold);
                    }
                });
                
                return allChars;
            }
            
            // 通常の処理（子要素がない場合）
            // 不要なスペース・改行を正規化
            // - 先頭/末尾の空白を削除
            // - 連続する空白(半角/全角/NBSP/改行/タブ)を単一の半角スペースに圧縮
            const normalized = element.textContent
                .replace(/[\u00A0\u3000]/g, ' ') // NBSP/全角スペース→半角スペース
                .replace(/[\s\t\r\n]+/g, ' ')   // 連続空白を1つに
                .trim();

            // b（可動部分）を返す
            const movers = normalized.split('').map(char => {
                const span = document.createElement('span'); // カット用コンテナ（overflowはCSS側で）
                span.style.display = 'inline-block';

                const bold = document.createElement('b'); // アニメーション対象
                // 1つのスペースのみ NBSP にして折り返し時の欠落を防止
                bold.textContent = char === ' ' ? '\u00A0' : char;
                bold.style.display = 'inline-block';
                bold.style.transform = 'translateY(120%)';
                bold.style.opacity = '0';

                span.appendChild(bold);
                return span;
            });

            // DOM反映
            element.innerHTML = '';
            movers.forEach(span => element.appendChild(span));

            // 返り値は b 要素配列
            return Array.from(element.querySelectorAll('span > b'));
        }

        // スロットアニメーション関数
        function animateSlotText(chars, direction = 'down') {
            if (!chars) return;
            
            gsap.to(chars, {
                y: 0,
                opacity: 1,
                duration: 0.45,
                stagger: 0.015,
                ease: "power3.out"
            });
        }

        // フェードアウトアニメーション
        function fadeOutText(chars, direction = 'down') {
            if (!chars) return;
            
            const yTo = direction === 'down' ? '-110%' : '120%';
            
            gsap.to(chars, {
                y: yTo,
                opacity: 0,
                duration: 0.3,
                stagger: 0.008,
                ease: "power2.inOut"
            });
        }

        // 各アイテムのテキストを分割（説明は複数要素を想定）
        const itemTexts = [];
        waItems.forEach((item, index) => {
            const title = item.querySelector('.wa__title');
            const descriptions = Array.from(item.querySelectorAll('.wa__description'));
            // 各アイテム内の背景/画像フレーム
            const bgFrames = Array.from(item.querySelectorAll('.wa__backgrounds .wa__background, .wa__background'));
            const imgFrames = Array.from(item.querySelectorAll('.wa__images .wa__image, .wa__image'));
            
            // デバッグ: フレーム数を確認
            // 画像フレームの内側ラッパーを準備（なければ自動生成）
            imgFrames.forEach(frame => {
                if (!frame.querySelector('.wa__image-inner')) {
                    const inner = document.createElement('div');
                    inner.className = 'wa__image-inner';
                    const img = frame.querySelector('img');
                    if (img) {
                        frame.replaceChild(inner, img);
                        inner.appendChild(img);
                    } else {
                        frame.appendChild(inner);
                    }
                }
            });
            
            // 全アイテムでテキスト分割を実行
            itemTexts[index] = {
                titleChars: splitText(title),
                descCharsList: descriptions.map(el => splitText(el)),
                bgFrames,
                imgFrames,
                // 直近のフレーム記録（アニメ用）
                lastImgFrameIndex: -1,
                lastBgFrameIndex: -1,
                currentFrame: 0 // Progressベースで計算される現在のフレームインデックス
            };

            // 初期化: フレームの初期状態を明示（重なり防止）
            if (bgFrames && bgFrames.length) {
                bgFrames.forEach((el, i) => {
                    el.classList.toggle('is-active', i === 0);
                    el.classList.toggle('wa__background--active', i === 0);
                    gsap.set(el, { opacity: i === 0 ? 1 : 0 });
                });
                itemTexts[index].lastBgFrameIndex = 0;
            }
            if (imgFrames && imgFrames.length) {
                imgFrames.forEach((el, i) => {
                    el.classList.toggle('is-active', i === 0);
                    el.classList.toggle('wa__image--active', i === 0);
                    gsap.set(el, { opacity: i === 0 ? 1 : 0, scale: 1 });
                });
                itemTexts[index].lastImgFrameIndex = 0;
            }
        });

        // 初期の自動再生は行わない（初回スクロールでアイテム1を再生）

        // ページャーの初期設定
        pagerCurrents.forEach((pagerCurrent, index) => {
            if (index === 0) {
                // 最初のアイテムのページャーを表示
                pagerCurrent.style.opacity = '1';
                pagerCurrent.textContent = '01';
            } else {
                // 他のアイテムのページャーを非表示
                pagerCurrent.style.opacity = '0';
            }
        });

        // デバッグ用の計測データ
        const debugData = {
            itemStartTimes: {},
            itemDurations: {},
            lastItem: null,
            lastSwitchTime: 0,
            totalScrollStart: 0,
            switchCount: 0,
            lastProgress: undefined, // スクロール方向判定用（progressベース）
            displayProgress: null // 表示用にスムージングしたprogress（アイテムの複数スキップ防止）
        };

        // CSS sticky + GSAP スクロール連動実装
        // 1アイテムあたりのスクロール量（px）
        // 注意: この値はスクロール範囲の計算用のみで、アイテム/フレームの切り替えには使用されません
        // アイテム/フレームの切り替えは progress ベースで自動的に行われます
        const perItemScrollPx = 1200;
        const itemCount = waItems.length;
        const totalScrollHeight = perItemScrollPx * itemCount;
        
        // 初期化時に位置を事前調整（固定開始をスムーズに、marginを個別に設定）
        gsap.set(waContent, {
            x: 0,
            y: 0,
            top: 'auto',
            left: 0,
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
            marginBottom: 0,
            force3D: true
        });
        
        // ScrollTriggerでスクロール進行度を監視（sticky要素用）
        
        const ensureFullWidthPin = (triggerInstance) => {
            if (!triggerInstance) return;
            const pinElement = triggerInstance.pin || waContent;
            if (!pinElement) return;

            const isMobile = window.innerWidth <= 767;
            const widthValue = isMobile ? '100vw' : `${window.innerWidth}px`;
            // setPropertyでimportantフラグを付けて確実に上書き（根本的な解決）
            pinElement.style.setProperty('margin', '0', 'important');
            pinElement.style.setProperty('margin-top', '0', 'important');
            pinElement.style.setProperty('margin-left', '0', 'important');
            pinElement.style.setProperty('margin-right', '0', 'important');
            pinElement.style.setProperty('margin-bottom', '0', 'important');
            
            // 位置とサイズを確実に設定（marginに依存しない）
            gsap.set(pinElement, {
                left: 0,
                right: 0,
                marginTop: 0,
                marginLeft: 0,
                marginRight: 0,
                marginBottom: 0,
                width: widthValue,
                maxWidth: widthValue,
                x: 0,
                y: 0,
                top: 0,
                force3D: true
            });
            // インラインスタイルも設定（important付き）
            pinElement.style.setProperty('top', '0', 'important');
            pinElement.style.setProperty('left', '0', 'important');
            pinElement.style.setProperty('right', '0', 'important');
            pinElement.style.setProperty('width', widthValue, 'important');
            pinElement.style.setProperty('max-width', widthValue, 'important');
        };

        const waScrollTrigger = ScrollTrigger.create({
            trigger: waContent,
            start: 'top top', // 要素の上端がビューポートの上端に到達した時に固定開始
            end: `+=${totalScrollHeight}px`, // 総スクロール範囲を可変に
            pin: true, // ピン機能を有効化
            pinSpacing: false, // ピン時のスペースを無効化
            anticipatePin: 1, // 予測処理を有効化（スムーズなpin開始）
            scrub: 0.1, // スクロール連動の滑らかさを調整（アニメーション用、pinには影響しない）
            refreshPriority: -1, // 他のScrollTriggerより先に更新（位置のずれを防止）
            invalidateOnRefresh: true, // リフレッシュ時に再計算（正確な位置を維持）
            pinReparent: false, // pin時のDOM操作を最小化（パフォーマンス向上）
            markers: false, // デバッグ用マーカー（一時的に無効）
            onStart: (self) => {
                // ScrollTriggerが開始される前に位置を調整（pin開始前）
                if (self.direction === 1) { // 下方向スクロール
                    // 位置を事前に調整（marginを個別に設定）
                    gsap.set(waContent, {
                        x: 0,
                        y: 0,
                        marginTop: 0,
                        marginLeft: 0,
                        marginRight: 0,
                        marginBottom: 0,
                        force3D: true
                    });
                }
            },
            onToggle: (self) => {
                // pin開始/終了時に即座に位置を調整（onEnterより早く実行される）
                if (self.isActive) {
                    // pin開始時にCSSクラスを追加してmarginを完全に上書き（根本的な解決）
                    waContent.classList.add('wa__content--pinned');
                    
                    // 位置を確実に設定（marginに依存しない）
                    const isMobile = window.innerWidth <= 767;
                    const widthValue = isMobile ? '100vw' : `${window.innerWidth}px`;
                    const forceRemoveMargin = () => {
                        // getComputedStyleで実際のmargin値を確認
                        const computed = window.getComputedStyle(waContent);
                        const marginLeft = parseFloat(computed.marginLeft);
                        const marginRight = parseFloat(computed.marginRight);
                        
                        // setPropertyでimportantフラグを付けて確実に上書き（根本的な解決）
                        waContent.style.setProperty('margin', '0', 'important');
                        waContent.style.setProperty('margin-top', '0', 'important');
                        waContent.style.setProperty('margin-left', '0', 'important');
                        waContent.style.setProperty('margin-right', '0', 'important');
                        waContent.style.setProperty('margin-bottom', '0', 'important');
                        
                        // marginが残っている場合は強制的に削除
                        if (Math.abs(marginLeft) > 0.1 || Math.abs(marginRight) > 0.1) {
                            // removeProperty + setPropertyで確実に削除
                            waContent.style.removeProperty('margin');
                            waContent.style.removeProperty('margin-left');
                            waContent.style.removeProperty('margin-right');
                            waContent.style.setProperty('margin', '0', 'important');
                            waContent.style.setProperty('margin-left', '0', 'important');
                            waContent.style.setProperty('margin-right', '0', 'important');
                        }
                        
                        gsap.set(waContent, {
                            x: 0,
                            y: 0,
                            top: 0,
                            left: 0,
                            right: 0,
                            width: widthValue,
                            maxWidth: widthValue,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            force3D: true,
                            immediateRender: true,
                            clearProps: 'transform' // 既存のtransformをクリア
                        });
                        
                        // インラインスタイルも確実に設定（important付き）
                        waContent.style.setProperty('top', '0', 'important');
                        waContent.style.setProperty('left', '0', 'important');
                        waContent.style.setProperty('right', '0', 'important');
                        waContent.style.setProperty('width', widthValue, 'important');
                        waContent.style.setProperty('max-width', widthValue, 'important');
                    };
                    
                    // 即座に実行
                    forceRemoveMargin();
                    
                    // requestAnimationFrameで再度確認（複数回実行）
                    requestAnimationFrame(() => {
                        forceRemoveMargin();
                        requestAnimationFrame(() => {
                            forceRemoveMargin();
                            // 最終確認
                            const computed = window.getComputedStyle(waContent);
                            const marginLeft = parseFloat(computed.marginLeft);
                            const marginRight = parseFloat(computed.marginRight);
                            if (Math.abs(marginLeft) > 0.1 || Math.abs(marginRight) > 0.1) {
                            }
                        });
                    });
                } else {
                    // pin終了時にクラスを削除
                    waContent.classList.remove('wa__content--pinned');
                }
            },
            onEnter: () => {
                
                // CSSクラスを追加してmarginを完全に上書き
                waContent.classList.add('wa__content--pinned');
                
                // 位置を強制的に調整（固定開始直後に確実に実行、marginを完全に削除）
                const alignPosition = () => {
                    // getComputedStyleで実際のmargin値を確認
                    const computed = window.getComputedStyle(waContent);
                    const marginLeft = parseFloat(computed.marginLeft);
                    const marginRight = parseFloat(computed.marginRight);
                    
                    // setPropertyでimportantフラグを付けて確実に上書き（根本的な解決）
                    waContent.style.setProperty('margin', '0', 'important');
                    waContent.style.setProperty('margin-top', '0', 'important');
                    waContent.style.setProperty('margin-left', '0', 'important');
                    waContent.style.setProperty('margin-right', '0', 'important');
                    waContent.style.setProperty('margin-bottom', '0', 'important');
                    
                    // marginが残っている場合は強制的に削除
                    if (Math.abs(marginLeft) > 0.1 || Math.abs(marginRight) > 0.1) {
                        // removeProperty + setPropertyで確実に削除
                        waContent.style.removeProperty('margin');
                        waContent.style.removeProperty('margin-left');
                        waContent.style.removeProperty('margin-right');
                        waContent.style.setProperty('margin', '0', 'important');
                        waContent.style.setProperty('margin-left', '0', 'important');
                        waContent.style.setProperty('margin-right', '0', 'important');
                    }
                    
                    const isMobile = window.innerWidth <= 767;
                    const widthValue = isMobile ? '100vw' : `${window.innerWidth}px`;
                    gsap.set(waContent, {
                        x: 0,
                        y: 0,
                        top: 0,
                        left: 0,
                        right: 0,
                        width: widthValue,
                        maxWidth: widthValue,
                        marginTop: 0,
                        marginLeft: 0,
                        marginRight: 0,
                        marginBottom: 0,
                        force3D: true,
                        immediateRender: true
                    });
                    // インラインスタイルも確実に設定（important付き）
                    waContent.style.setProperty('top', '0', 'important');
                    waContent.style.setProperty('left', '0', 'important');
                    waContent.style.setProperty('right', '0', 'important');
                    waContent.style.setProperty('width', widthValue, 'important');
                    waContent.style.setProperty('max-width', widthValue, 'important');
                    // 再度チェックして確実に位置を調整
                    requestAnimationFrame(() => {
                        const rect = waContent.getBoundingClientRect();
                        if (Math.abs(rect.top) > 0.1 || Math.abs(rect.left) > 0.1) {
                            // marginを再度削除
                            waContent.style.removeProperty('margin');
                            waContent.style.removeProperty('margin-left');
                            waContent.style.removeProperty('margin-right');
                            gsap.set(waContent, {
                                x: 0,
                                y: 0,
                                top: 0,
                                left: 0,
                                right: 0,
                                marginTop: 0,
                                marginLeft: 0,
                                marginRight: 0,
                                marginBottom: 0,
                                force3D: true
                            });
                        }
                    });
                };
                // 即座に実行 + requestAnimationFrameで確実に
                alignPosition();
                requestAnimationFrame(alignPosition);
                requestAnimationFrame(alignPosition); // 3回実行で確実に
                
                debugData.totalScrollStart = Date.now();
                // 初回スクロール進入でアイテム1を確実に再生
                if (itemTexts[0]) {
                    if (itemTexts[0].titleChars) gsap.set(itemTexts[0].titleChars, { y: '120%', opacity: 0 });
                    if (itemTexts[0].descCharsList) itemTexts[0].descCharsList.forEach(chars => gsap.set(chars, { y: '120%', opacity: 0 }));
                    // 先頭フレームを有効化
                    const { bgFrames, imgFrames } = itemTexts[0];
                    if (bgFrames && bgFrames.length) bgFrames.forEach((el, i) => {
                        const active = i === 0;
                        el.classList.toggle('is-active', active);
                        el.classList.toggle('wa__background--active', active);
                    });
                    if (imgFrames && imgFrames.length) imgFrames.forEach((el, i) => {
                        const active = i === 0;
                        el.classList.toggle('is-active', active);
                        el.classList.toggle('wa__image--active', active);
                    });
                    if (itemTexts[0].titleChars) animateSlotText(itemTexts[0].titleChars);
                    if (itemTexts[0].descCharsList) itemTexts[0].descCharsList.forEach(chars => animateSlotText(chars));
                }
            },
            onEnterBack: () => {
                // CSSクラスを追加してmarginを完全に上書き
                waContent.classList.add('wa__content--pinned');
                // 位置を確実に調整
                requestAnimationFrame(() => {
                    const rect = waContent.getBoundingClientRect();
                    const computed = window.getComputedStyle(waContent);
                    const marginLeft = parseFloat(computed.marginLeft);
                    const marginRight = parseFloat(computed.marginRight);
                    
                    if (Math.abs(rect.top) > 0.1 || Math.abs(rect.left) > 0.1 || Math.abs(marginLeft) > 0.1 || Math.abs(marginRight) > 0.1) {
                        // setPropertyでimportantフラグを付けて確実に上書き
                        waContent.style.setProperty('margin', '0', 'important');
                        waContent.style.setProperty('margin-left', '0', 'important');
                        waContent.style.setProperty('margin-right', '0', 'important');
                        
                        const isMobile = window.innerWidth <= 767;
                        const widthValue = isMobile ? '100vw' : `${window.innerWidth}px`;
                        gsap.set(waContent, {
                            x: 0,
                            y: 0,
                            top: 0,
                            left: 0,
                            right: 0,
                            width: widthValue,
                            maxWidth: widthValue,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            force3D: true,
                            immediateRender: true
                        });
                        // インラインスタイルも確実に設定（important付き）
                        waContent.style.setProperty('top', '0', 'important');
                        waContent.style.setProperty('left', '0', 'important');
                        waContent.style.setProperty('right', '0', 'important');
                        waContent.style.setProperty('width', widthValue, 'important');
                        waContent.style.setProperty('max-width', widthValue, 'important');
                    }
                });
            },
            onLeave: () => {
                
                // 最後のアイテムの表示時間を記録
                if (debugData.lastItem !== null) {
                    const finalTime = Date.now();
                    const finalDuration = finalTime - debugData.lastSwitchTime;
                    debugData.itemDurations[debugData.lastItem] = finalDuration;
                }
                
                // 最終的な計測結果を表示
                Object.keys(debugData.itemDurations).forEach(itemIndex => {
                    const duration = debugData.itemDurations[itemIndex];
                });
            },
            onUpdate: (self) => {
                const progress = self.progress; // 実際のprogress（0.0 ～ 1.0）
                
                // ピン固定中は常に位置を監視して調整（スティッキーのようにスムーズに）
                if (self.isActive) {
                    const rect = waContent.getBoundingClientRect();
                    const threshold = 0.5; // 0.5px以上のずれを検出
                    
                    // 位置がずれている場合は即座に修正（marginを完全に削除）
                    if (Math.abs(rect.top) > threshold || Math.abs(rect.left) > threshold) {
                        // setPropertyでimportantフラグを付けて確実に上書き（根本的な解決）
                        waContent.style.setProperty('margin', '0', 'important');
                        waContent.style.setProperty('margin-left', '0', 'important');
                        waContent.style.setProperty('margin-right', '0', 'important');
                        
                        const isMobile = window.innerWidth <= 767;
                        const widthValue = isMobile ? '100vw' : `${window.innerWidth}px`;
                        gsap.set(waContent, {
                            x: 0,
                            y: 0,
                            top: 0,
                            left: 0,
                            right: 0,
                            width: widthValue,
                            maxWidth: widthValue,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            force3D: true,
                            immediateRender: true
                        });
                        // インラインスタイルも確実に設定（important付き）
                        waContent.style.setProperty('top', '0', 'important');
                        waContent.style.setProperty('left', '0', 'important');
                        waContent.style.setProperty('right', '0', 'important');
                        waContent.style.setProperty('width', widthValue, 'important');
                        waContent.style.setProperty('max-width', widthValue, 'important');
                    }
                    
                    // progress === 0 の時は特に念入りにチェック（marginを完全に削除）
                    if (self.progress === 0) {
                        requestAnimationFrame(() => {
                            const rect2 = waContent.getBoundingClientRect();
                            if (Math.abs(rect2.top) > threshold || Math.abs(rect2.left) > threshold) {
                                // setPropertyでimportantフラグを付けて確実に上書き（根本的な解決）
                                waContent.style.setProperty('margin', '0', 'important');
                                waContent.style.setProperty('margin-left', '0', 'important');
                                waContent.style.setProperty('margin-right', '0', 'important');
                                
                                const isMobile = window.innerWidth <= 767;
                                const widthValue = isMobile ? '100vw' : `${window.innerWidth}px`;
                                gsap.set(waContent, {
                                    x: 0,
                                    y: 0,
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    width: widthValue,
                                    maxWidth: widthValue,
                                    marginTop: 0,
                                    marginLeft: 0,
                                    marginRight: 0,
                                    marginBottom: 0,
                                    force3D: true
                                });
                                // インラインスタイルも確実に設定（important付き）
                                waContent.style.setProperty('top', '0', 'important');
                                waContent.style.setProperty('left', '0', 'important');
                                waContent.style.setProperty('right', '0', 'important');
                                waContent.style.setProperty('width', widthValue, 'important');
                                waContent.style.setProperty('max-width', widthValue, 'important');
                            }
                        });
                    }
                }
                
                // progressベースでアイテムを決定（スキップを防止）
                // 参考: https://elementis.co/ の実装方式
                const totalItems = waItems.length;

                // 表示用progressをスムージングして、一度に複数のアイテムが切り替わらないようにする
                if (typeof debugData.displayProgress !== 'number') {
                    debugData.displayProgress = progress;
                } else {
                    const maxStep = totalItems > 0 ? (1 / totalItems) : 1;
                    let delta = progress - debugData.displayProgress;
                    if (delta > maxStep) {
                        delta = maxStep;
                    } else if (delta < -maxStep) {
                        delta = -maxStep;
                    }
                    debugData.displayProgress += delta;
                }
                const epsilon = 0.000001;
                const effectiveProgress = Math.min(Math.max(debugData.displayProgress, 0), 1 - epsilon);
                
                // progressをアイテム数で分割して、確実に1つずつ切り替わるようにする
                // Math.floor()を使用することで、スクロール速度に関わらず順次切り替え
                let currentItem = Math.floor(effectiveProgress * totalItems);
                
                // 最後のアイテムの範囲を超えた場合の処理
                if (currentItem >= totalItems) {
                        currentItem = totalItems - 1;
                }
                
                // アイテム内のprogressを計算（0.0 ～ 1.0）
                const itemProgress = (effectiveProgress * totalItems) - currentItem;
                
                // デバッグ: アイテム判定の詳細
                if (debugData.switchCount < 5 || debugData.switchCount % 10 === 0) {
                }
                
                // アイテム切り替えの計測
                const currentTime = Date.now();
                
                // スクロール方向の判定（安定性向上）
                const scrollDirection = debugData.lastProgress !== undefined ? 
                    (progress > debugData.lastProgress ? 'down' : 'up') : 'unknown';
                debugData.lastProgress = progress;
                
                // デバッグ: 切り替え判定の詳細
                if (debugData.switchCount < 3) {
                }
                
                if (debugData.lastItem !== currentItem) {
                    // アイテムが切り替わった
                    
                    if (debugData.lastItem !== null) {
                        // 前のアイテムの表示時間を記録
                        const duration = currentTime - debugData.lastSwitchTime;
                        debugData.itemDurations[debugData.lastItem] = duration;
                        const direction = currentItem > debugData.lastItem ? '前進' : '後退';
                    }
                    
                    // 新しいアイテムの開始時間を記録
                    debugData.itemStartTimes[currentItem] = currentTime;
                    debugData.lastSwitchTime = currentTime;
                    debugData.switchCount++;
                    
                    // 新しいアイテムのフレームを取得
                    if (itemTexts[currentItem]) {
                        const newItem = waItems[currentItem];
                        const newBgFrames = newItem.querySelectorAll('.wa__backgrounds .wa__background, .wa__background');
                        const newImgFrames = newItem.querySelectorAll('.wa__images .wa__image, .wa__image');
                        
                        // フレーム数が確定したら、itemProgressからフレームインデックスを計算
                            const framesCount = Math.max(
                                newBgFrames.length,
                                newImgFrames.length,
                                1
                            );
                        
                        // progressベースでフレームを決定（スキップを防止）
                        let frameIndex = Math.floor(itemProgress * framesCount);
                        if (frameIndex >= framesCount) {
                            frameIndex = framesCount - 1;
                        }
                        
                        itemTexts[currentItem].currentFrame = frameIndex;
                        
                        // 背景フレームの初期化
                        if (newBgFrames && newBgFrames.length) {
                            newBgFrames.forEach((el, i) => {
                                const active = i === itemTexts[currentItem].currentFrame;
                                el.classList.toggle('is-active', active);
                                el.classList.toggle('wa__background--active', active);
                                gsap.set(el, { opacity: active ? 1 : 0 });
                            });
                            itemTexts[currentItem].lastBgFrameIndex = itemTexts[currentItem].currentFrame;
                        }
                        
                        // 画像フレームの初期化
                        if (newImgFrames && newImgFrames.length) {
                            newImgFrames.forEach((el, i) => {
                                const active = i === itemTexts[currentItem].currentFrame;
                                el.classList.toggle('is-active', active);
                                el.classList.toggle('wa__image--active', active);
                                gsap.set(el, { opacity: active ? 1 : 0 });
                            });
                            itemTexts[currentItem].lastImgFrameIndex = itemTexts[currentItem].currentFrame;
                        }
                        
                        
                        // フレーム表示状態の確認
                        if (debugData.switchCount < 3) {
                        }
                        
                        // 後退時の特別処理: 最後のフレームが確実に表示されるようにする
                        if (currentItem < (debugData.lastItem || -1)) {
                            
                            // 最後のフレームの表示を確実にする
                            const lastFrameIndex = itemTexts[currentItem].currentFrame;
                            if (newBgFrames && newBgFrames.length > lastFrameIndex && newBgFrames[lastFrameIndex]) {
                                gsap.set(newBgFrames[lastFrameIndex], { opacity: 1, scale: 1 });
                            }
                            if (newImgFrames && newImgFrames.length > lastFrameIndex && newImgFrames[lastFrameIndex]) {
                                gsap.set(newImgFrames[lastFrameIndex], { opacity: 1 });
                            }
                        }
                    }
                }
                debugData.lastItem = currentItem;
                
                // デバッグログを簡素化（重要な情報のみ）
                // ログは削除済み
                
                // アクティブアイテムの切り替えとアニメーション
                waItems.forEach((item, index) => {
                    if (index === currentItem) {
                        item.classList.add('wa__item--active');
                        // アニメーション実行
                        if (itemTexts[index] && itemTexts[index].titleChars) {
                            animateSlotText(itemTexts[index].titleChars);
                        }
                        if (itemTexts[index] && itemTexts[index].descCharsList) {
                            itemTexts[index].descCharsList.forEach(chars => animateSlotText(chars));
                        }

                        // アイテム内フレーム切替（progressベース）
                        // 動的にフレーム数を取得（リアルタイムでDOMから取得）
                        const currentBgFrames = item.querySelectorAll('.wa__backgrounds .wa__background, .wa__background');
                        const currentImgFrames = item.querySelectorAll('.wa__images .wa__image, .wa__image');
                        const framesCount = Math.max(
                            currentBgFrames.length,
                            currentImgFrames.length,
                            1
                        );
                        
                        // アイテム内のprogressからフレームインデックスを計算
                        // アイテム内のprogress: (effectiveProgress * totalItems) - currentItem
                        const itemLocalProgress = (effectiveProgress * totalItems) - currentItem;
                        let frameIndex = Math.floor(itemLocalProgress * framesCount);
                        
                        // フレーム数の範囲チェック
                        if (frameIndex >= framesCount) {
                            frameIndex = framesCount - 1;
                        }
                        if (frameIndex < 0) {
                            frameIndex = 0;
                        }
                        
                        // 状態を更新
                        const state = itemTexts[index];
                        state.currentFrame = frameIndex;
                        
                        // デバッグ: フレーム切替の詳細
                        if (debugData.switchCount < 3) {
                        }
                        
                        // 動的に取得したフレームを使用
                        if (currentBgFrames && currentBgFrames.length) {
                            currentBgFrames.forEach((el, i) => {
                                const active = i === frameIndex;
                                el.classList.toggle('is-active', active);
                                el.classList.toggle('wa__background--active', active);
                                // すべてのフレームのopacityを明示的に設定
                                gsap.set(el, { opacity: active ? 1 : 0 });
                            });
                            // 背景フレームの切り替え（即座に切り替え、重なりを防止）
                            const prevBg = itemTexts[index].lastBgFrameIndex;
                            if (prevBg !== frameIndex) {
                                // 前のフレームを即座に非表示
                                if (prevBg >= 0 && currentBgFrames[prevBg]) {
                                    gsap.set(currentBgFrames[prevBg], { opacity: 0 });
                                }
                                // 新しいフレームを即座に表示
                                const incomingBg = currentBgFrames[frameIndex];
                                if (incomingBg) {
                                    gsap.set(incomingBg, { opacity: 1, scale: 1 });
                                }
                                itemTexts[index].lastBgFrameIndex = frameIndex;
                            }
                        }
                        
                        if (currentImgFrames && currentImgFrames.length) {
                            
                            currentImgFrames.forEach((el, i) => {
                                const active = i === frameIndex;
                                el.classList.toggle('is-active', active);
                                el.classList.toggle('wa__image--active', active);
                                // すべてのフレームのopacityを明示的に設定
                                gsap.set(el, { opacity: active ? 1 : 0 });
                            });
                            // フレーム切替アニメーション（画像・即座切り替え版：背景と同様の処理）
                            const prev = itemTexts[index].lastImgFrameIndex;
                            if (prev !== frameIndex) {
                                // 前のフレームを即座に非表示
                                if (prev >= 0 && currentImgFrames[prev]) {
                                    gsap.set(currentImgFrames[prev], { opacity: 0 });
                                }
                                // 新しいフレームを即座に表示
                                const incoming = currentImgFrames[frameIndex];
                                if (incoming) {
                                    gsap.set(incoming, { opacity: 1 });
                                }
                                itemTexts[index].lastImgFrameIndex = frameIndex;
                            }
                        } else {
                        }
                    } else {
                        item.classList.remove('wa__item--active');
                        // フェードアウトアニメーション + レイアウト維持のための初期位置に戻す
                        if (itemTexts[index] && itemTexts[index].titleChars) {
                            fadeOutText(itemTexts[index].titleChars);
                            gsap.set(itemTexts[index].titleChars, { y: '120%', opacity: 0 });
                        }
                        if (itemTexts[index] && itemTexts[index].descCharsList) {
                            itemTexts[index].descCharsList.forEach(chars => {
                                fadeOutText(chars);
                                gsap.set(chars, { y: '120%', opacity: 0 });
                            });
                        }
                        // 非アクティブ時は全フレームを非表示にする
                        const inactiveBgFrames = item.querySelectorAll('.wa__backgrounds .wa__background, .wa__background');
                        const inactiveImgFrames = item.querySelectorAll('.wa__images .wa__image, .wa__image');
                        
                        if (inactiveBgFrames && inactiveBgFrames.length) {
                            inactiveBgFrames.forEach((el, i) => {
                                el.classList.remove('is-active', 'wa__background--active');
                                gsap.set(el, { opacity: 0 });
                            });
                        }
                        
                        if (inactiveImgFrames && inactiveImgFrames.length) {
                            inactiveImgFrames.forEach((el, i) => {
                                el.classList.remove('is-active', 'wa__image--active');
                                gsap.set(el, { opacity: 0 });
                            });
                        }
                        
                    }
                });
                
                // ページャーの更新（各項目のページャーを個別に更新）
                pagerCurrents.forEach((pagerCurrent, index) => {
                    if (index === currentItem) {
                        // 現在のアイテムのページャーを表示
                        pagerCurrent.style.opacity = '1';
                        pagerCurrent.textContent = String(currentItem + 1).padStart(2, '0');
                    } else {
                        // 他のアイテムのページャーを非表示
                        pagerCurrent.style.opacity = '0';
                    }
                });
                
                // リアルタイム計測結果の表示（5秒ごと）
                if (debugData.switchCount > 0 && debugData.switchCount % 10 === 0) {
                    Object.keys(debugData.itemDurations).forEach(itemIndex => {
                        const duration = debugData.itemDurations[itemIndex];
                    });
                }
            }
        });

        if (waScrollTrigger) {
            const refreshHandler = () => ensureFullWidthPin(waScrollTrigger);
            ensureFullWidthPin(waScrollTrigger);
            ScrollTrigger.addEventListener('refreshInit', refreshHandler);
            ScrollTrigger.addEventListener('refresh', refreshHandler);
        }

    }

    // ページ読み込み完了後に初期化
    // 初期化フラグ
    let isInitialized = false;

    // 初期化関数
    function initializeWorksArchive() {
        if (isInitialized) {
            return;
        }

        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            return;
        }

        const waContent = document.querySelector('.wa__content');
        if (!waContent) {
            // 要素が見つからない場合は静かに終了（エラーログを出さない）
            return;
        }

        isInitialized = true;
        
        // CSS変数でスクロール範囲を動的に設定
        const waElement = document.querySelector('.wa');
        const waItems = document.querySelectorAll('.wa__item');
        if (waElement && waItems.length > 0) {
            const perItemScrollPx = 1200;
            const itemCount = waItems.length;
            const totalScrollHeight = perItemScrollPx * itemCount;
            waElement.style.setProperty('--scroll-height', `${totalScrollHeight}px`);
        }
        
        initWorksArchive();
        
        // 初期化完了の確認
        const waItemsCount = document.querySelectorAll('.wa__item').length;
        const pagerCount = document.querySelectorAll('.wa__pager-current').length;
    }

    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initializeWorksArchive, 500);
    });

    // ウィンドウ読み込み完了後にも初期化を試行
    window.addEventListener('load', function() {
        setTimeout(initializeWorksArchive, 100);
    });

    // GSAPが読み込まれた後に初期化
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        setTimeout(initializeWorksArchive, 200);
    } else {
        // GSAPがまだ読み込まれていない場合、定期的にチェック
        let gsapCheckInterval = setInterval(() => {
            if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
                clearInterval(gsapCheckInterval);
                setTimeout(initializeWorksArchive, 200);
            }
        }, 100);
        
        // 10秒後にタイムアウト
        setTimeout(() => {
            clearInterval(gsapCheckInterval);
        }, 10000);
    }

    // リサイズ時の再初期化
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            ScrollTrigger.refresh();
        }, 250);
    });

    // ページ読み込み完了後の再計算
    window.addEventListener('load', function() {
        setTimeout(function() {
            ScrollTrigger.refresh();
        }, 1000);
    });

})();
